import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { UserService } from '../services/user.service';
import { getUserHomePage } from '../utils';

@Injectable({ providedIn: 'root' })
export class DashboardGuard {
  private router = inject(Router);
  private userService = inject(UserService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isGc = this.userService.getUser().is_company_gc;

    if (!isGc) {
      const page = getUserHomePage(this.userService.getUser());
      this.router.navigate([page]);
      return false;
    }
    return true;
  }
}
